import styled from 'styled-components';

/** @component */
export default styled.ul`
  list-style: none;
  margin: 0;
`;
